export default __webpack_public_path__ + "static/media/Services-Bg.da93f010.jpg";